
















































































import CommonIconBtn from '@/components/Common/CommonIconBtn.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'studentQuerySearchDisplay',
  components: {
    CommonIconBtn,
  }
})
export default class extends Vue {
  @Prop({ required: true }) public data!: any;
  @Prop({ required: false }) public show!: boolean;
  @Prop({ required: false }) public updateData!: boolean;

  get showSearchDisplay() {
    const data = this.displayData;
    return this.show && (data.keyWord || data.fkAreaCountryIdName|| data.applyAreaCountryIdName || data.fkInstitutionIdName || data.createStartTime || data.createEndTime || data.openTimeStart || data.openTimeEnd || data.changeStep.join() || data.gmtCreateUser.join());
  }

  public displayData: any = {
    keyWord: '',
    fkAreaCountryIdName: '',
    applyAreaCountryIdName: '',
    fkInstitutionIdName: '',
    createStartTime: '',
    createEndTime: '',
    changeStep: [],
    gmtCreateUser: [],
    createTimeRange: [],
    openTimeStart: '',
    openTimeEnd: '',
    openTimeRange: [],
  }

  @Watch('updateData')
  public updateDisplayData(val: boolean) {
    if (val) {
      this.displayData = Object.assign({}, this.data);
    }
  }

  public clear(key: string) {
    if (['changeStep', 'gmtCreateUser'].includes(key)) {
      this.displayData[key] = [];
    } else {
      this.displayData[key] = '';
    }
    this.$emit('clear-search', key);
  }
}
